// extracted by mini-css-extract-plugin
module.exports = {"container":"GraphYScale_container__2FXAQ","scaleWrapper":"GraphYScale_scaleWrapper__3xQxX","scaleItem":"GraphYScale_scaleItem__2jgiy"};